// Domyślnie ten sam origin co front (nginx proxuje /api/ na backend).
import { apiFetch } from './api/apiFetch';
const apiUrl = process.env.REACT_APP_API_URL || '/api/';

export const fetchProducts = async (url) => {
  try {
    const response = await apiFetch(`${apiUrl}${url}`);

    if (!response.ok) {
      return [];
    }

    const data = await response.json();
    return data;

  } catch (error) {
    console.error('There was an error fetching the products!', error);
    return [];
  }
};